





















































































import { LoginService } from "@/services/login.service";
import Alerta from "@/shared/components/alerts.vue";
import Desktop from "@/shared/components/desktop.vue";
import GlobalLoader from "@/shared/components/global-loader.vue";
import Mobile from "@/shared/components/mobile.vue";
import Toast from "@/shared/components/toast.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { required, validEmail } from "@/shared/validators";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Component, Mixins } from "vue-property-decorator";

dayjs.extend(customParseFormat);

@Component({
  components: {
    Desktop,
    Mobile,
    Alerta,
    Toast,
    GlobalLoader,
  },
})
export default class Login extends Mixins(GlobalMixin) {
  loading = false;
  inputPassType = "password";

  usuario = {
    email: "",
    senha: "",
  };

  rules = {
    email: [required(), validEmail()],
    senha: [required()],
  };

  login() {
    const form = this.$refs.form as any;

    if (form.validate()) {
      const returnUrl = this.$route.query.returnUrl;
      this.startLoader();
      LoginService.login(this.usuario, returnUrl as string)
        .then(() => {
          if (returnUrl) window.location.href = returnUrl as string;
          else
            this.$router.replace({
              name: "home",
            });
        })
        .finally(this.stopLoader);
    }
  }

  togglePasswordType() {
    this.inputPassType =
      (this.inputPassType == "password" && "text") || "password";
  }
}
